/* =============================================================================
 * REVIV Serums — Sticky PDP "Add to Cart" Bar — VARIANT B v2.1 — SEPARATED BUILD
 * JS ONLY — assumes reviv-sticky-bar.liquid markup + reviv-sticky-bar.css are
 * already on the page (via {% render 'reviv-sticky-bar' %} + stylesheet_tag).
 *
 * DIFFERENCES vs the original inline-injection script:
 *   - No innerHTML markup building — the bar is now static Liquid markup;
 *     this script only SELECTS it (#reviv-sticky-bar) and wires behavior.
 *   - No injectStyles() — CSS now lives in reviv-sticky-bar.css.
 *   - ADDED: openCartDrawer() — after Add to Cart succeeds, this tries a
 *     sequence of common Shopify cart-drawer triggers (theme events, cart
 *     icon click, custom elements) so the drawer actually opens instead of
 *     just adding silently to the cart.
 *
 * Toggle logging:  window.__revivStickyDebug = false;
 * ========================================================================== */
(function () {
  'use strict';

  var NS = '%c[reviv-sticky v2.1]';
  var STYLE = 'color:#DD52CD;font-weight:700;';
  if (typeof window.__revivStickyDebug === 'undefined') window.__revivStickyDebug = true;
  function on() { return !!window.__revivStickyDebug; }
  function log() { if (on()) try { console.log.apply(console, [NS, STYLE].concat([].slice.call(arguments))); } catch (e) { } }
  function info() { if (on()) try { console.info.apply(console, [NS, STYLE].concat([].slice.call(arguments))); } catch (e) { } }
  function warn() { try { console.warn.apply(console, ['[reviv-sticky v2.1]'].concat([].slice.call(arguments))); } catch (e) { } }

  log('script evaluated. document.readyState =', document.readyState,
    '| __revivStickyDebug =', window.__revivStickyDebug);

  /* --- Step 1: guards ------------------------------------------------------ */
  if (window.__revivStickyBarV2Init) {
    log('v2 idempotency guard already set — bailing (already initialized this session).');
    return;
  }
  window.__revivStickyBarV2Init = true;
  log('v2 idempotency guard set: window.__revivStickyBarV2Init = true');

  // Page guard: PDPs only.
  var pathOk = location.pathname.indexOf('/products/') !== -1;
  var tplOk = document.documentElement.getAttribute('data-template') === 'product';
  log('page guard:', { pathname: location.pathname, pathOk: pathOk, dataTemplate: document.documentElement.getAttribute('data-template'), tplOk: tplOk });
  if (!(pathOk && tplOk)) { log('NOT a PDP — bailing (this is correct on non-product pages).'); return; }
  info('PDP confirmed — proceeding.');

  /* --- helpers ------------------------------------------------------------- */
  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return (root || document).querySelectorAll(sel); }

  function isVisible(el) {
    if (!el) return false;
    if (el.getAttribute && el.getAttribute('aria-hidden') === 'true') return false;
    if (el.offsetParent === null && el.getClientRects().length === 0) return false;
    var cs;
    try { cs = window.getComputedStyle(el); } catch (e) { return true; }
    if (!cs) return true;
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    if (parseFloat(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 1 && r.height > 1;
  }

  function desc(el) {
    if (!el) return '(null)';
    var cls = (el.className && el.className.baseVal != null ? el.className.baseVal : el.className) || '';
    return el.tagName.toLowerCase() + (el.id ? '#' + el.id : '') +
      (cls ? '.' + String(cls).trim().split(/\s+/).join('.') : '');
  }

  function clean(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }

  /* --- product title resolution ------------------------------------------- */
  var TITLE_SELECTORS = [
    '.main-product__title',
    '.prod-main-title',
    '.product__title',
    '.product-single__title',
    'h1.product-title',
    '.main-product h1',
    '#c_productform h1',
    'h1'
  ];

  function productTitle() {
    for (var i = 0; i < TITLE_SELECTORS.length; i++) {
      var el = q(TITLE_SELECTORS[i]);
      var t = el ? clean(el.textContent) : '';
      if (t) return { text: t, source: TITLE_SELECTORS[i] + ' -> ' + desc(el) };
    }
    try {
      var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      if (m && m.title) return { text: clean(m.title), source: 'ShopifyAnalytics.meta.product.title' };
    } catch (e) { }
    var og = q('meta[property="og:title"]');
    if (og && clean(og.getAttribute('content'))) return { text: clean(og.getAttribute('content')), source: 'meta[og:title]' };
    return { text: '', source: '(none)' };
  }

  /* --- robust wait: DOM-ready THEN poll for the form ----------------------- */
  function whenDomReady(cb) {
    if (document.readyState === 'loading') {
      log('document still loading — waiting for DOMContentLoaded…');
      document.addEventListener('DOMContentLoaded', function () {
        log('DOMContentLoaded fired.');
        cb();
      });
    } else {
      log('DOM already interactive/complete — proceeding immediately.');
      cb();
    }
  }

  function waitFor(testFn, cb, timeoutMs) {
    var start = Date.now();
    var tries = 0;
    var hit = testFn();
    if (hit) { log('waitFor: required elements present immediately.'); cb(hit); return; }
    log('waitFor: not ready — polling every 120ms (timeout ' + timeoutMs + 'ms)…');
    var iv = setInterval(function () {
      tries++;
      var r = testFn();
      if (r) { clearInterval(iv); log('waitFor: ready after ' + tries + ' poll(s), ' + (Date.now() - start) + 'ms.'); cb(r); return; }
      if (Date.now() - start > timeoutMs) {
        clearInterval(iv);
        warn('TIMEOUT: required elements not found after ' + timeoutMs + 'ms / ' + tries + ' polls. Dumping what we DID find:');
        getEls(true);
      }
    }, 120);
  }

  /* --- Step 2: resolve native elements ------------------------------------ */
  // Selectors matched to the actual PDP markup (main-product section):
  //   form            #c_productform
  //   ATC button      .addtocartbtn
  //   qty input       #qtynumber (inc/dec via #qty-minus / #qty-plus)
  //   live price      .prod-main-price  (span.money.notranslate — THIS is the
  //                    node any currency-converter app rewrites, so it is the
  //                    only reliable source of truth for price sync)
  //   compare/sale    #reviv-order-total .reviv-order-sale / .reviv-order-compare
  //   price container .main-product__total (observe this whole block — currency
  //                    apps typically rewrite text nodes inside it)
  function getEls(report) {
    var form = q('#c_productform') || q('form[action^="/cart/add"]') || q('form.shopify-product-form');
    var scope = form || document;
    var atc = q('.addtocartbtn', scope) || q('.main-product__addtocard-btn', scope) || q('[type="submit"]', scope);
    var qty = q('#qtynumber', scope) || q('input[name="quantity"]', scope);
    var currentPrice = q('.prod-main-price') || q('#reviv-order-total .reviv-order-sale') || q('.price__current');
    var anchor = q('.main-product__addtocard') || q('.main-product__total') || atc;
    if (report) {
      var t = productTitle();
      log('getEls() report:', {
        form: desc(form), atc: desc(atc), qty: desc(qty),
        qtyMinus: desc(q('#qty-minus')), qtyPlus: desc(q('#qty-plus')),
        currentPrice: desc(currentPrice), anchor: desc(anchor),
        productTitle: t.text || '(empty)', titleSource: t.source
      });
    }
    return {
      form: form, atc: atc, qty: qty, qtyMinus: q('#qty-minus'), qtyPlus: q('#qty-plus'),
      currentPrice: currentPrice, priceBlock: q('.main-product__total'), anchor: anchor
    };
  }

  /* --- boot ---------------------------------------------------------------- */
  whenDomReady(function () {
    log('boot: starting waitFor for #c_productform + .addtocartbtn …');
    waitFor(function () { var e = getEls(); return (e.form && e.atc) ? e : null; }, build, 8000);
  });

  /* ========================================================================= */
  function build(els) {
    info('build() starting.');
    if (!els.form || !els.atc) { warn('missing required element at build time; aborting.'); getEls(true); return; }

    // CHANGED: the bar is now STATIC Liquid markup — we select it instead of
    // building it with innerHTML. Make sure {% render 'reviv-sticky-bar' %}
    // is present on the PDP template.
    var bar = document.getElementById('reviv-sticky-bar');
    if (!bar) {
      warn('#reviv-sticky-bar not found in DOM — did you render the reviv-sticky-bar.liquid snippet on this template?');
      return;
    }

    var reduceMotion = false;
    try { reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { }
    log('prefers-reduced-motion:', reduceMotion);
    if (reduceMotion) bar.classList.add('reviv-sticky--no-anim');

    info('bar found in static markup.', bar);
    log('sanity: computed z-index =', (function () { try { return window.getComputedStyle(bar).zIndex; } catch (e) { return '?'; } })());

    // NOTE ON CURRENCY: price is intentionally NOT trusted from Liquid alone.
    // Currency-converter apps (Shopify Markets, 3rd-party converters) rewrite
    // the REAL price node (.prod-main-price, class "money notranslate")
    // client-side after page load — a Liquid-rendered value in our own span
    // would silently go stale the moment the shopper switches currency.
    // So: .prod-main-price / .reviv-order-sale is treated as the single
    // source of truth, and we mirror it continuously (MutationObserver +
    // a low-frequency poll as a safety net for apps that don't trigger
    // clean DOM mutations, e.g. ones that redraw via requestAnimationFrame).
    var elPrice = q('[data-reviv-price]', bar) || q('.reviv-sticky__price', bar);
    var elTitle = q('[data-reviv-title]', bar) || q('.reviv-sticky__title', bar);
    var elQtyNum = q('[data-reviv-qty-num]', bar) || q('.reviv-sticky__qty-num', bar);
    var elAtc = q('[data-reviv-atc]', bar) || q('.reviv-sticky__atc', bar);
    var qtyBtns = bar.querySelectorAll('[data-reviv-qty]');

    /* --- mirror price (currency-safe) -------------------------------------- */
    function priceText(node) {
      if (!node) return '';
      // if the node ITSELF carries the "money" class (as .prod-main-price
      // does: class="prod-main-price money notranslate"), read it directly —
      // don't only look at descendants, or a currency app that rewrites the
      // node's own textContent gets missed.
      var money = node;
      if (!(node.classList && node.classList.contains('money'))) {
        money = node.querySelector('.money') || node;
      }
      var t = (money.textContent || '').trim();
      if (!t && money.getAttribute) t = (money.getAttribute('data-current-value') || '').trim();
      return t;
    }
    var lastPriceText = '';
    function mirrorPrice(reason) {
      var pt = priceText(els.currentPrice);
      if (!pt) { log('mirrorPrice: no live price text found yet — leaving current sticky-bar price as-is.'); return; }
      if (pt === lastPriceText) return; // avoid noisy re-writes
      lastPriceText = pt;
      elPrice.textContent = pt;
      log('mirrorPrice: price set to "' + pt + '"' + (reason ? ' (' + reason + ')' : ''));
    }
    mirrorPrice('initial sync');
    if (els.priceBlock) {
      var mT;
      try {
        var priceObs = new MutationObserver(function () { clearTimeout(mT); mT = setTimeout(function () { mirrorPrice('DOM mutation — likely currency change'); }, 50); });
        priceObs.observe(els.priceBlock, { subtree: true, childList: true, characterData: true, attributes: true });
        log('price MutationObserver attached on .main-product__total (catches currency-app rewrites).');
      } catch (e) { }
    }
    // Safety-net poll: some currency-picker apps redraw price nodes in ways
    // that don't fire a MutationObserver reliably (e.g. replacing whole
    // subtrees via a framework re-render). Cheap 1s poll catches those too.
    setInterval(function () { mirrorPrice('safety-net poll'); }, 1000);
    // If the theme/app dispatches a currency-change event, react immediately
    // instead of waiting for the next poll tick.
    ['currency:change', 'shopify:currency:change', 'currencyChanged'].forEach(function (evtName) {
      document.addEventListener(evtName, function () { mirrorPrice('event: ' + evtName); });
    });

    /* --- mirror product title (title doesn't change with currency, kept for parity) --- */
    function mirrorTitle() {
      var r = productTitle();
      if (!r.text) { log('mirrorTitle: nothing found — leaving server-rendered Liquid title as-is.'); return false; }
      elTitle.textContent = r.text;
      elTitle.setAttribute('title', r.text);
      log('mirrorTitle: "' + r.text + '" (source: ' + r.source + ')');
      return true;
    }

    /* --- quantity two-way sync -------------------------------------------- */
    function readQty() { var v = parseInt(els.qty && els.qty.value, 10); if (isNaN(v) || v < 1) v = 1; return v; }
    function minQty() { var m = parseInt(els.qty && els.qty.getAttribute('min'), 10); return (isNaN(m) || m < 1) ? 1 : m; }
    function reflectToSticky() { var v = readQty(); elQtyNum.textContent = String(v); log('qty reflect native -> sticky: display =', v); }
    function reflectAfter() { setTimeout(reflectToSticky, 0); }
    function stepQty(delta) {
      if (!els.qty) { warn('stepQty: no native qty input.'); return; }
      var before = readQty();
      if (delta > 0 && els.qtyPlus) { log('stepQty(+1): clicking native #qty-plus (before=' + before + ')'); els.qtyPlus.click(); reflectAfter(); return; }
      if (delta < 0 && els.qtyMinus) { log('stepQty(-1): clicking native #qty-minus (before=' + before + ')'); els.qtyMinus.click(); reflectAfter(); return; }
      var next = Math.max(minQty(), before + delta);
      log('stepQty(' + delta + '): fallback set value ' + before + ' -> ' + next);
      els.qty.value = String(next);
      els.qty.dispatchEvent(new Event('input', { bubbles: true }));
      els.qty.dispatchEvent(new Event('change', { bubbles: true }));
      reflectToSticky();
    }
    for (var qi = 0; qi < qtyBtns.length; qi++) {
      (function (btn) {
        btn.addEventListener('click', function () { var d = parseInt(btn.getAttribute('data-reviv-qty'), 10); log('sticky qty button clicked, delta =', d); stepQty(d); });
      })(qtyBtns[qi]);
    }
    if (els.qty) {
      els.qty.addEventListener('input', reflectToSticky);
      els.qty.addEventListener('change', reflectToSticky);
      try { var qtyObs = new MutationObserver(reflectToSticky); qtyObs.observe(els.qty, { attributes: true, attributeFilter: ['value'] }); log('qty MutationObserver attached.'); } catch (e) { }
    }
    reflectToSticky();

    /* --- ADDED: open the cart drawer ---------------------------------------
     * Tries, in order:
     *   1. Common Shopify theme JS APIs / globals (theme.cart.open, etc.)
     *   2. Common custom events themes listen for (cart:open, cart:refresh)
     *   3. Clicking a visible cart-drawer trigger element (icon/link/button)
     * Stops at the first thing that seems to work; logs every attempt so you
     * can see exactly which hook your theme actually responded to.
     * ---------------------------------------------------------------------- */
    var CART_TRIGGER_SELECTORS = [
      '[data-cart-drawer-toggle]',
      '[data-action="open-cart-drawer"]',
      '.js-drawer-open-cart',
      '.cart-link',
      '#cart-icon-bubble',
      'a[href="/cart"]',
      '.header__icon--cart',
      '.site-header__cart-toggle',
      '[data-cart-toggle]'
    ];

    function tryThemeApi() {
      try {
        if (window.theme && window.theme.cart && typeof window.theme.cart.open === 'function') {
          window.theme.cart.open();
          log('openCartDrawer: called window.theme.cart.open().');
          return true;
        }
      } catch (e) { }
      try {
        if (typeof window.CartDrawer !== 'undefined' && window.CartDrawer && typeof window.CartDrawer.open === 'function') {
          window.CartDrawer.open();
          log('openCartDrawer: called window.CartDrawer.open().');
          return true;
        }
      } catch (e) { }
      var drawerEl = document.querySelector('cart-drawer, .cart-drawer, [data-cart-drawer]');
      try {
        if (drawerEl && typeof drawerEl.open === 'function') {
          drawerEl.open();
          log('openCartDrawer: called .open() on', desc(drawerEl));
          return true;
        }
      } catch (e) { }
      return false;
    }

    function dispatchCartEvents() {
      var names = ['cart:open', 'cart:refresh', 'cart:build', 'cart:updated', 'ajaxProduct:added'];
      for (var i = 0; i < names.length; i++) {
        try {
          document.dispatchEvent(new CustomEvent(names[i], { bubbles: true, detail: {} }));
          log('openCartDrawer: dispatched document event "' + names[i] + '".');
        } catch (e) { }
      }
    }

    function clickCartTrigger() {
      for (var i = 0; i < CART_TRIGGER_SELECTORS.length; i++) {
        var el = q(CART_TRIGGER_SELECTORS[i]);
        if (el && isVisible(el)) {
          log('openCartDrawer: clicking fallback trigger "' + CART_TRIGGER_SELECTORS[i] + '" ->', desc(el));
          el.click();
          return true;
        }
      }
      warn('openCartDrawer: no theme API, no responding event, and no visible cart trigger found. Add your theme\'s selector to CART_TRIGGER_SELECTORS.');
      return false;
    }

    function openCartDrawer() {
      log('openCartDrawer: attempting to open the cart drawer after add-to-cart…');
      if (tryThemeApi()) return;
      dispatchCartEvents();
      // Give theme JS a beat to react to the dispatched events (e.g. it may
      // fetch /cart.js and render the drawer itself) before falling back to
      // clicking a visible cart icon.
      setTimeout(function () {
        if (!detectCartOpen(false)) clickCartTrigger();
      }, 300);
    }

    /* --- add to cart ------------------------------------------------------ */
    elAtc.addEventListener('click', function () {
      if (elAtc.disabled) { log('ATC click ignored (busy).'); return; }
      var qv = els.qty ? els.qty.value : '?';
      info('sticky ATC clicked -> clicking native .addtocartbtn (qty=' + qv + ').');
      els.atc.click();
      elAtc.disabled = true;
      elAtc.classList.add('reviv-sticky--busy');
      openCartDrawer();
      setTimeout(function () { elAtc.disabled = false; elAtc.classList.remove('reviv-sticky--busy'); log('ATC re-enabled.'); }, 1000);
    });

    /* --- show/hide state -------------------------------------------------- */
    var scrolledPast = false;
    var cartOpen = false;

    function apply() {
      var shouldShow = scrolledPast && !cartOpen;
      var isShown = bar.classList.contains('reviv-sticky--visible');
      if (shouldShow && !isShown) { bar.classList.add('reviv-sticky--visible'); log('bar SHOWN.'); }
      else if (!shouldShow && isShown) {
        bar.classList.remove('reviv-sticky--visible');
        log('bar HIDDEN (' + (cartOpen ? 'cart open' : 'ATC visible or still below the fold') + ').');
      }
      setTeaserHidden(shouldShow);
    }

    var teaserHost = null;
    var teaserSuppressing = false;

    function teaserHideNode(node) {
      if (!node) return;
      node.style.setProperty('visibility', 'hidden', 'important');
      node.style.setProperty('pointer-events', 'none', 'important');
    }
    function teaserShowNode(node) {
      if (!node) return;
      node.style.removeProperty('visibility');
      node.style.removeProperty('pointer-events');
    }
    function eachTeaserNode(host, fn) {
      if (!host) return;
      if (host.shadowRoot) {
        var inner = host.shadowRoot.getElementById('app-embed');
        if (inner) fn(inner);
      }
      fn(host);
    }
    function teaserIsCollapsed(host) {
      if (!host) return false;
      var inner = host.shadowRoot ? host.shadowRoot.getElementById('app-embed') : null;
      var step = inner && inner.getAttribute('data-current-step');
      return step === 'tease';
    }
    function setTeaserHidden(hide) {
      if (!teaserHost) return;
      teaserSuppressing = true;
      var collapsed = teaserIsCollapsed(teaserHost);
      var doHide = hide && collapsed;
      eachTeaserNode(teaserHost, doHide ? teaserHideNode : teaserShowNode);
      teaserSuppressing = false;
      if (hide && !collapsed) {
        log('signup teaser is EXPANDED (form modal open) — leaving it visible; bar stays under it.');
      } else {
        log('signup teaser ' + (doHide ? 'HIDDEN (bar visible)' : 'RESTORED (bar hidden)') + '.');
      }
    }

    (function startTeaserToggle() {
      function findHost() { return document.querySelector('shopify-forms-embed'); }
      function attach(host) {
        teaserHost = host;
        info('signup teaser host <shopify-forms-embed> found — toggling with the bar.', host);
        try {
          var target = host.shadowRoot || host;
          var mo = new MutationObserver(function () {
            if (teaserSuppressing) return;
            log('signup teaser re-rendered by its app — re-applying current bar state.');
            setTeaserHidden(bar.classList.contains('reviv-sticky--visible'));
          });
          mo.observe(target, {
            subtree: true, attributes: true,
            attributeFilter: ['style', 'class', 'data-position', 'data-current-step']
          });
          log('signup teaser MutationObserver attached on ' + (host.shadowRoot ? 'shadowRoot' : 'host') + '.');
        } catch (e) { warn('signup teaser observer failed:', e); }
        setTeaserHidden(bar.classList.contains('reviv-sticky--visible'));
      }
      var existing = findHost();
      if (existing) { attach(existing); return; }
      log('signup teaser <shopify-forms-embed> not in DOM yet — polling up to ~15s.');
      var tries = 0;
      var iv = setInterval(function () {
        var host = findHost();
        if (host) { clearInterval(iv); attach(host); }
        else if (++tries > 75) { clearInterval(iv); warn('signup teaser host never appeared (bar still works).'); }
      }, 200);
    })();

    /* --- (a) direction-aware scroll detection ---------------------------- */
    var anchor = els.anchor;
    function computePast() {
      var r = anchor.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var before = scrolledPast;
      scrolledPast = (r.bottom <= 8);
      if (before !== scrolledPast) {
        log('computePast: anchor.top=' + Math.round(r.top) + ' bottom=' + Math.round(r.bottom) +
          ' vh=' + vh + ' -> scrolledPast=' + scrolledPast +
          (scrolledPast ? ' (ATC left the TOP)' : (r.top > vh ? ' (ATC still BELOW the fold)' : ' (ATC visible)')));
      }
    }

    if (anchor && 'IntersectionObserver' in window) {
      log('using IntersectionObserver + rect (direction-aware) on anchor:', desc(anchor));
      var io = new IntersectionObserver(function () { computePast(); apply(); }, { threshold: [0, 0.01, 1] });
      io.observe(anchor);
      var ioTick = false;
      window.addEventListener('scroll', function () {
        if (ioTick) return;
        ioTick = true;
        window.requestAnimationFrame(function () { computePast(); apply(); ioTick = false; });
      }, { passive: true });
      computePast();
      apply();
    } else if (anchor) {
      warn('IntersectionObserver unsupported — scroll fallback.');
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { computePast(); apply(); ticking = false; });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    } else {
      warn('no scroll anchor; showing when cart closed.');
      scrolledPast = true;
    }

    /* --- (b) cart-open detection ----------------------------------------- */
    var CART_HINT_SELECTORS = [
      '.Drawer--fromRight', '.dv-custom-cart', '.c_cart_drawer_overlay',
      '.cart-drawer', '#sidebar-cart', '.cart__inner', '.cart__wrapper'
    ];

    function detectCartOpen(report) {
      var vw = window.innerWidth || document.documentElement.clientWidth;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = 0; i < CART_HINT_SELECTORS.length; i++) {
        var nodes = qa(CART_HINT_SELECTORS[i]);
        for (var j = 0; j < nodes.length; j++) {
          var el = nodes[j];
          if (el === bar || el.tagName === 'BUTTON') continue;
          var vis = isVisible(el);
          var cs; try { cs = window.getComputedStyle(el); } catch (e) { cs = null; }
          var pos = cs ? cs.position : '?';
          var overlay = (pos === 'fixed' || pos === 'absolute' || pos === 'sticky');
          var r = el.getBoundingClientRect();
          var onScreen = r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
          var sizable = r.width > vw * 0.3 && r.height > vh * 0.25;
          var match = vis && overlay && onScreen && sizable;
          if (report) {
            log('  hint "' + CART_HINT_SELECTORS[i] + '" ->', desc(el),
              {
                visible: vis, position: pos, overlay: overlay, onScreen: onScreen, sizable: sizable,
                w: Math.round(r.width), h: Math.round(r.height), top: Math.round(r.top)
              });
          }
          if (match) { if (report) log('  => CART OPEN match on', desc(el)); return true; }
        }
      }
      if (report) log('  => no cart container matched: cart CLOSED.');
      return false;
    }

    function refreshCartState() {
      var now = detectCartOpen(false);
      if (now !== cartOpen) { cartOpen = now; info('cart detected ' + (now ? 'OPEN' : 'CLOSED') + '.'); apply(); }
    }
    refreshCartState();

    try {
      var cartObs = new MutationObserver(function () {
        if (cartObs._t) return;
        cartObs._t = window.requestAnimationFrame(function () { cartObs._t = 0; refreshCartState(); });
      });
      cartObs.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class', 'style', 'aria-hidden', 'data-state'], childList: true });
      log('cart MutationObserver attached on <body>.');
    } catch (e) { warn('cart observer failed:', e); }

    document.addEventListener('click', function () { setTimeout(refreshCartState, 50); setTimeout(refreshCartState, 400); }, true);
    elAtc.addEventListener('click', function () { var n = 0; var iv = setInterval(function () { refreshCartState(); if (++n >= 8) clearInterval(iv); }, 250); });

    apply();
    info('build() complete. Bar is live. Scroll down to see it.');
    info('To debug cart hiding: open the cart, then run  window.__reviv.why()');
    info('To check the title source: window.__reviv.title()');

    window.__reviv = {
      bar: bar, els: els,
      refresh: refreshCartState,
      isCartOpen: function () { return cartOpen; },
      isScrolledPast: function () { return scrolledPast; },
      title: function () { var r = productTitle(); log('title(): "' + r.text + '" (source: ' + r.source + ')'); return r; },
      remirrorTitle: mirrorTitle,
      openCart: openCartDrawer,
      why: function () {
        log('--- why(): cart detection trace ---');
        var r = detectCartOpen(true);
        log('--- why(): detectCartOpen()=' + r + ' | cartOpen=' + cartOpen + ' scrolledPast=' + scrolledPast + ' ---');
        return r;
      },
      forceShow: function () { scrolledPast = true; cartOpen = false; apply(); log('forceShow(): bar forced visible.'); },
      forceHide: function () { scrolledPast = false; apply(); }
    };
    log('debug handles exposed: window.__reviv', window.__reviv);
  }
})();